import React from 'react'

const ProjectSlider = () => {
    return (
        <div id="FeaturedCarouselIndicators" className="carousel slide" data-ride="carousel" data-interval="7000">
		<ol className="carousel-indicators">
			<li data-target="#FeaturedCarouselIndicators" data-slide-to="0" className="active"></li>
			<li data-target="#FeaturedCarouselIndicators" data-slide-to="1"></li>
		</ol>
		<div className="carousel-inner" role="listbox">
	
	<div className="carousel-item active f-1">
			<div className="testimonial-section">
                <div className="container"> 
                    <div className="row">
                        <div className="col-lg-5 col-md-12 featured-text align-self-center">
                            <h3>Featured Project</h3>
                            <hr color="orange" />
                                <h1>CarArabiya</h1>
                                <p>Cararabiya is an online virtual marketplace for car shoppers and sellers. Cararabiya offers complete online and seamless car buying experience. Our platform communicates in real time with every car manufacturer, credit bureaus, and lenders to deliver a seamless A-Z car sale from a single platform.
                                </p>
                                <button type="button" className="btn btn-outline-light">read more</button>
                                
                        </div>
                        <div className="col-lg-7 col-md-12 featured-image-1">
                                <img src={'./img/featured-cararabiya.png'} className="img-fluid" />					
                        </div>
                        
                        </div>
                        
                </div> 
	
            </div>
	</div>	
	<div className="carousel-item f-2" >
			<div className="testimonial-section">
	<div className="container"> 
		<div className="row">
			<div className="col-lg-5 col-md-12 featured-text align-self-center">
				<h3>Featured Project</h3>
				<hr color="orange" />
					<h1>Tijarat</h1>
					<p>Tijarat – a commodity-trading platform designed for brokers and Islamic Banks – has created an optimum environment for the trading of any commodities in real time. Islamic banks, Islamic windows of conventional banks and Islamic finance companies can make use of the platform to provide cash..
            		</p>
           			<button type="button" className="btn btn-outline-light">read more</button>
					
			</div>
			<div className="col-lg-7 col-md-12 featured-image-2">
				<img src={"img/featured-tijarat-1.png"} className="img-fluid" />					
			</div>
			
			</div>
			
	</div> 
	
	</div>
	</div>
</div>

</div>
  
    )
}

export default ProjectSlider
